import React from 'react';
import './PortfolioSection.css';

const PortfolioSection = () => {
  const projects = [
    {
      title: 'Chat Application',
      description: 'A fully functional chat application which work like Social Media Apps. We can add someone for chat.',
      imageUrl: 'https://cdn.pixabay.com/photo/2015/11/06/15/13/internet-1028794_1280.jpg',
      // demoUrl: 'https://www.youtube.com/watch?v=XASY30EfGAc',
      codeUrl: 'https://github.com/Programmerhub123/Chat-Application',
    },
    {
      title: 'Blog Site',
      description: 'I have developed this fully functional blog site using React.js. It contains all the functionality that a professional blog site should have.',
      imageUrl: 'https://plus.unsplash.com/premium_photo-1720744786849-a7412d24ffbf?q=80&w=2009&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      // demoUrl: 'https://example.com/demo2',
      codeUrl: 'https://github.com/Programmerhub123/Bloging-site',
    },
    {
      title: 'Dashboard UI',
      description: 'This professional Dashboard has been designed using React.js. It contains all the functionalities to manage the UI of the user.',
      imageUrl: 'Dashboard UI.JPG',
      // demoUrl: 'https://example.com/demo3',
      codeUrl: 'https://github.com/Programmerhub123/Dashboard-UI',
    },
    {
      title: 'Movie Point',
      description: 'This site facilitates users to search for movies of their interest. Users can watch available movies or search for others.',
      imageUrl: 'Movie Point.JPG',
      // demoUrl: 'https://example.com/demo3',
      codeUrl: 'https://github.com/Programmerhub123/Movie-Point.git',
    },
    {
      title: 'Hamid Portfolio',
      description: 'This is my portfolio site that contains details of my education, portfolio, and expertise.',
      imageUrl: 'Hamid Portfolio.JPG',
      // demoUrl: 'https://example.com/demo3',
      codeUrl: 'https://github.com/Programmerhub123/Hamid-Portfolio.git',
    },
    {
      title: 'E-Commerce Site',
      description: 'An E-Commerce site developed in React.js with all the functionalities needed for a fully-fledged commerce platform.',
      imageUrl: 'E-commerce.JPG',
      // demoUrl: 'https://example.com/demo3',
      codeUrl: 'https://github.com/Programmerhub123/Hamid-Portfolio.git',
    },
    {
      title: 'Weather App',
      description: 'A weather app developed in React.js that provides real-time weather updates and forecasts.',
      imageUrl: 'Weather-app.JPG',
      // demoUrl: 'https://example.com/demo3',
      codeUrl: 'https://github.com/Programmerhub123/Weather-App.git',
    },
    {
      title: 'Word Counter',
      description: 'This word counter app counts the total number of characters and words in a given text.',
      imageUrl: 'Word count.JPG',
      // demoUrl: 'https://example.com/demo3',
      codeUrl: 'https://github.com/Programmerhub123/Word-Counter.git',
    },
    {
      title: 'Fitness Point',
      description: 'A dynamic fitness app developed using React.js, offering personalized workout plans and progress tracking.',
      imageUrl: 'Fitness.JPG',
      // demoUrl: 'https://example.com/demo3',
      codeUrl: 'https://github.com/Programmerhub123/Fitness-Point.git',
    },
    {
      title: 'E-Learning App',
      description: 'An e-learning app offering online courses and learning materials, with features like quizzes and progress tracking.',
      imageUrl: 'training.WEBP',
      // demoUrl: 'https://example.com/demo3',
      codeUrl: 'https://github.com/Programmerhub123/E-Learning-App.git',
    },
    {
      title: 'Quizz App',
      description: 'A dynamic quiz app that offers multiple categories and timed quizzes with score tracking and leaderboards.',
      imageUrl: 'quizz.png',
      // demoUrl: 'https://example.com/demo3',
      codeUrl: 'https://github.com/Programmerhub123/quizz-app.git',
    },
    {
      title: 'Tour Booking',
      description: 'A tour booking app that allows users to book and manage travel plans, offering various destinations and packages.',
      imageUrl: 'travel.jpg',
      // demoUrl: 'https://example.com/demo3',
      codeUrl: 'https://github.com/Programmerhub123/Travel.git',
    },
    {
      title: 'MY To-Do List',
      description: 'The to-do list project allows users to create, manage, and organize tasks efficiently. Users can add new tasks, mark them as completed, delete them, and edit their details. Task filtering by status helps manage priorities.',
      imageUrl: 'todo.jpg',
      // demoUrl: 'https://example.com/demo3',
      codeUrl: 'https://github.com/Programmerhub123/To-Do-List.git',
    },
    {
      title: 'Job Portal',
      description: 'A modern job portal that connects job seekers with employers, offering intuitive search features, personalized recommendations, and seamless application processes for enhanced recruitment efficiency.',
      imageUrl: 'portal.png',
      // demoUrl: 'https://example.com/demo3',
      codeUrl: 'https://github.com/Programmerhub123/Jobs-Portal.git',
    },
  ];

  return (
    <section id="portfolio" className="portfolio-section">
      <h2>Portfolio</h2>
      <div className="projects">
        {projects.map((project, index) => (
          <div className="project" key={index}>
            <img src={project.imageUrl} alt={project.title} />
            <div className="project-info">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <div className="project-links">
                {project.demoUrl && (
                  <a href={project.demoUrl} target="_blank" rel="noopener noreferrer" className="styled-button">Demo</a>
                )}
                {project.codeUrl && (
                  <a href={project.codeUrl} target="_blank" rel="noopener noreferrer" className="styled-button">Code</a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PortfolioSection;
